// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderHorizontalOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderHorizontalOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderHorizontalOutlined = function BorderHorizontalOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderHorizontalOutlinedSvg
  }));
};

BorderHorizontalOutlined.displayName = 'BorderHorizontalOutlined';
export default React.forwardRef(BorderHorizontalOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BorderHorizontalOutlined.js
// module id = 657
// module chunks = 0